export default __webpack_public_path__ + "static/demo_keberkesanan_sabun_champaca_3-5debe18b113150622c0f7e6929fde07f.mp4";